import { render, staticRenderFns } from "./NoPatient.vue?vue&type=template&id=b6167c2a&"
import script from "./NoPatient.vue?vue&type=script&lang=js&"
export * from "./NoPatient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports